/**
 * WP8 · BK-Profil — Pflichtfeld-Validierung
 *
 * Analog zu `pflege/profile/validation.ts`, aber mit dem schlanken
 * BK-Pflichtfeld-Satz (anrede/vorname/nachname). Weitere Felder sind im
 * CRM 1.0 für BK nicht hart erforderlich.
 */
import type { BkFormState } from './sections';

/** Pflichtfelder des BK-Profils. */
export const BK_REQUIRED: Array<keyof BkFormState> = [
  'anrede',
  'vorname',
  'nachname',
];

/** Ordnet jeden Pflichtfeld-Key der Section zu, in der es liegt. */
export const BK_FIELD_SECTION_MAP: Partial<Record<keyof BkFormState, string>> = {
  anrede:   'stammdaten',
  vorname:  'stammdaten',
  nachname: 'stammdaten',
};

/** Ergebnis-Typ von validateBkProfile(). */
export interface BkValidationResult {
  /** Alle fehlenden Pflichtfeld-Keys. */
  missing: Array<keyof BkFormState>;
  /** Section-id des ersten fehlenden Feldes — für jump(). */
  firstSection: string | null;
}

/** Validiert den BK-Formular-State und gibt fehlende Pflichtfelder zurück. */
export function validateBkProfile(f: BkFormState): BkValidationResult {
  const missing = BK_REQUIRED.filter(k => {
    const v = f[k];
    return v == null || v === '' || (Array.isArray(v) && v.length === 0);
  });
  const firstSection =
    missing.length > 0 ? (BK_FIELD_SECTION_MAP[missing[0]] ?? null) : null;
  return { missing, firstSection };
}
